import { useTiptapEditor } from '../../../../../entities/tiptap-editor';
import { callModel } from '../../../../../features/call';
import { Button, Modal } from '../../../../../shared/ui';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { JSONContent } from '@tiptap/core';
import { InsertVariant } from './lib/config';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  callId: string;
  insertVariant: InsertVariant | null;
};

export const MakePublicModal: FC<Props> = ({
  isOpen,
  onClose,
  callId,
  insertVariant,
}) => {
  const { editor } = useTiptapEditor();
  const dispatch = useDispatch();
  const currentCall = useSelector(callModel.selectors.selectCurrentCall);

  const isLoading = useSelector(
    callModel.selectors.selectIsAssetPrivacyLoading
  );

  const handleConfirm = () => {
    dispatch(
      callModel.actions.makeCallPublicFromEditor({
        id: callId,
        isPreview: Boolean(currentCall),
        isInsertSummary: insertVariant === InsertVariant.WITH_SUMMARY,
        cb: (content: JSONContent[]) => {
          if (editor) {
            editor
              .chain()
              .insertContent([...content])
              .focus()
              .run();
          }

          onClose();
          dispatch(callModel.actions.loadCallsForEditor());
        },
      })
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Make call recording public"
      className="w-100"
      actionButton={
        <Button
          onClick={handleConfirm}
          fullWidth
          type="submit"
          color="primary"
          variant="text"
          loading={isLoading}
        >
          Apply
        </Button>
      }
    >
      <p className="text-sm text-gray-600">
        If you want to embed a video on your page, the call recording needs to
        be public so that your team and viewers can access it. Are you sure you
        want to make this recording public?
      </p>
    </Modal>
  );
};
